export default __webpack_public_path__ + "static/media/point-figure.35bc8ae8.svg";